export const Constants = {
    None:"none",
    Black:"#000000",
    White:"#FFFFFF",
    ButtonBorderWidth:"3px"
}